// This provides the underlying functionality for the little "t" button used in
// various places around the site (e.g., analytics/keywords, or the profile
// sidebar for the percentile stat). Use 'share_icons_twitter.png' with a custom
// on-click handler that sets up the tweet text and shareUrl, then hand off to
// this method to trigger display of the actual Twitter pop-up box.
if (!window.Academia) {
  window.Academia = {};
}
window.Academia.openTwitterShareWindow = function (tweetText, shareUrl, via) {
  let windowUrl = 'http://twitter.com/intent/tweet?text=' + encodeURIComponent(tweetText);
  if (shareUrl && shareUrl.length > 0) {
    windowUrl = windowUrl + '&url=' + encodeURIComponent(shareUrl);
  }
  if (via && via.length > 0) {
    windowUrl = windowUrl + '&via=' + encodeURIComponent(via);
  }
  const options = 'toolbar=0,scrollbars=1,resizable=1,width=600,height=400';
  window.open(windowUrl, '', options);
};